import React from "react";
import { CheckCircle } from "lucide-react";

export default function Programs() {
  const bookingUrl = "https://academy.suhasinibasa.com/web/checkout/6a8eb2e3570da12b73781f39";

  const tiers = [
    {
      level: "L0",
      name: "Fast Start Bundle",
      target: "Professionals seeking immediate, fast networking guidelines.",
      keyOutcome: "LinkedIn profile and active network optimization.",
      features: [
        "LinkedIn profile audit checklists",
        "Target network building framework",
        "Ready-to-use AI outreach prompts",
        "30-day job hunt roadmap blueprint"
      ],
      testId: "program-pricing-card-fast-start"
    },
    {
      level: "L1",
      name: "Silver Membership",
      target: "IT BAs & PMs looking for structured career progression.",
      keyOutcome: "Foundational structural leadership tools.",
      features: [
        "6-Step Core Curriculum",
        "1-1 Career Coaching Call",
        "Weekly Inner Circle Call",
        "90 Days Growth Challenge"
      ],
      testId: "program-pricing-card-silver"
    },
    {
      level: "L2",
      name: "Gold Membership",
      target: "Ambitious managers seeking stakeholder authority.",
      keyOutcome: "Advanced influence, visibility and presence.",
      features: [
        "Weekly mastermind cohorts",
        "Executive speech alignment",
        "50+ AI Prompts Toolkit for Project Execution",
        "90 Days Growth Challenge"
      ],
      highlight: true,
      testId: "program-pricing-card-gold"
    }
  ];

  return (
    <div className="relative bg-obsidian text-slate-100 min-h-screen">
      <div className="noise-overlay" />

      {/* Header */}
      <section className="relative py-20 lg:py-28 px-4 sm:px-6 lg:px-12 border-b border-white/5 overflow-hidden">
        <div className="absolute top-1/4 right-0 w-96 h-96 bg-gold/5 rounded-full blur-[120px] pointer-events-none" />
        <div className="max-w-4xl mx-auto text-left space-y-6 relative z-10">
          <span className="text-xs uppercase tracking-[0.25em] text-gold font-mono font-bold">THE CAREER HUB ROADMAP</span>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white leading-tight">
            Choose the level of support that fits your career
          </h1>
          <p className="text-lg sm:text-xl text-slate-300 leading-relaxed font-normal">
            No empty claims of automatic promotions. We offer highly structural, scenario-based corporate navigation blueprints to support your organic leadership progression.
          </p>
        </div>
      </section>

      {/* Tier Cards Section */}
      <section className="py-16 lg:py-24 px-4 sm:px-6 lg:px-12 bg-navy relative border-b border-white/5">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch">
            {tiers.map((tier, idx) => (
              <div 
                key={idx}
                data-testid={tier.testId}
                className={`p-6 sm:p-8 flex flex-col justify-between transition-all duration-300 ${
                  tier.highlight 
                    ? "bg-obsidian border-2 border-gold shadow-2xl relative" 
                    : "bg-obsidian/60 border border-white/5"
                }`}
              >
                {tier.highlight && (
                  <span className="absolute top-0 right-0 bg-gold text-obsidian text-[10px] font-mono font-bold tracking-widest px-3 py-1 uppercase">
                    HIGH VALUE
                  </span>
                )}

                <div className="space-y-6">
                  <div>
                    <span className="font-mono text-xs text-gold uppercase tracking-widest font-bold">
                      {tier.level} // LEVEL
                    </span>
                    <h3 className="font-display text-2xl font-bold text-white mt-1">{tier.name}</h3>
                  </div>

                  <div className="space-y-2 border-t border-white/10 pt-4 text-xs">
                    <p className="text-slate-400 font-bold uppercase tracking-wider">TARGET PROFESSIONAL:</p>
                    <p className="text-slate-300">{tier.target}</p>
                  </div>

                  <div className="space-y-2 border-t border-white/10 pt-4 text-xs">
                    <p className="text-slate-400 font-bold uppercase tracking-wider">PRIMARY OUTCOME:</p>
                    <p className="text-slate-300">{tier.keyOutcome}</p>
                  </div>

                  <div className="border-t border-white/10 pt-4 space-y-3">
                    <p className="text-xs text-slate-400 font-bold uppercase tracking-wider">KEY DELIVERABLES:</p>
                    {tier.features.map((feature, fIdx) => (
                      <div key={fIdx} className="flex items-start space-x-2 text-xs text-slate-300">
                        <CheckCircle className="w-4 h-4 text-gold shrink-0 mt-0.5" />
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="pt-8">
                  <a
                    href={bookingUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`programs-checkout-cta-${tier.level.toLowerCase()}`}
                    className={`w-full py-3 font-display font-bold text-xs uppercase tracking-widest block text-center transition-colors duration-200 ${
                      tier.highlight 
                        ? "bg-gold hover:bg-gold-hover text-obsidian" 
                        : "bg-white/5 hover:bg-white/10 text-white"
                    }`}
                  >
                    Explore &amp; Secure Access
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

    </div>
  );
}
